// Product data extracted from evLUXE source pages.
// Product images use non-destructive studio renders generated from the source assets.

import { publicAsset } from "./config";

const scooterImage = (name) =>
  publicAsset(`scooters/product-v6/${name.replace(/\.png$/i, ".jpg")}`);

const studioImage = (name) => publicAsset(`scooters/product-v7/${name}`);

const COMMON = {
  motor: "BLDC HUB (Water Proof)",
  speedMeter: "Digital LED",
  batteryType: "Lead-acid / Lithium-ion",
  suspension: "Hydraulic",
  batteryAmpere: "26 AH to 42 AH",
  maxLoading: "180 Kgs",
};

export const products = [
  {
    id: "xj",
    name: "CR2 PRO / XJ",
    series: "GITANJALI",
    tagline: "Flagship alloy-rim performer with full disc braking.",
    description:
      "The CR2 PRO / XJ blends a waterproof BLDC hub motor with dual disc braking and stylish alloy rims, engineered for confident, premium city riding.",
    images: [
      studioImage("xj-blue.webp"),
      studioImage("xj-red.webp"),
      studioImage("xj-white.webp"),
    ],
    colorNames: ["Nautic Blue", "Racing Red", "Pearl White"],
    specs: {
      ...COMMON,
      voltage: "60V / 72V",
      wheelRim: "Stylish Alloy Rim",
      brakingSystem: "Front Disc & Rear Disc",
      tyreSize: "90-90-12 (Tubeless)",
    },
  },
  {
    id: "sl8",
    name: "CR1 / SL8",
    series: "GITANJALI",
    tagline: "Dependable everyday commuter built for value.",
    description:
      "A practical, robust commuter with hydraulic suspension and a high 180 kg load capacity, ideal for daily Indian urban and semi-urban roads.",
    images: [
      studioImage("sl8-white.webp"),
      studioImage("sl8-blue.webp"),
      studioImage("sl8-red.webp"),
    ],
    colorNames: ["Pearl White", "Aqua Blue", "Racing Red"],
    specs: {
      ...COMMON,
      voltage: "48V / 60V",
      wheelRim: "Iron",
      brakingSystem: "Front Disc & Rear Drum",
      tyreSize: "90-90-12",
    },
  },
  {
    id: "fl",
    name: "CR2 PRO / FL",
    series: "GITANJALI",
    tagline: "Premium tubeless ride with dual disc control.",
    description:
      "The CR2 PRO / FL pairs a high-voltage platform with tubeless tyres and alloy rims for a smooth, planted, premium ride experience.",
    images: [
      scooterImage("cr2-pro-fl.png"),
      scooterImage("cr2-pro-fl-1.png"),
      scooterImage("cr2-pro-fl-2.png"),
    ],
    colorNames: ["Pearl White", "Racing Red", "Aqua Blue"],
    specs: {
      ...COMMON,
      voltage: "60V / 72V",
      wheelRim: "Stylish Alloy Rim",
      brakingSystem: "Front Disc & Rear Disc",
      tyreSize: "90-90-12 (Tubeless)",
    },
  },
  {
    id: "cr3",
    name: "CR3 PRO",
    series: "GITANJALI",
    tagline: "Versatile workhorse with flexible tyre options.",
    description:
      "Engineered for versatility, the CR3 PRO offers a balanced voltage platform, hydraulic suspension, and a strong load rating for varied use cases.",
    images: [
      studioImage("cr3-white.webp"),
      studioImage("cr3-red.webp"),
      studioImage("cr3-blue.webp"),
    ],
    colorNames: ["Pearl White", "Racing Red", "Aqua Blue"],
    specs: {
      ...COMMON,
      voltage: "48V / 60V",
      wheelRim: "Iron",
      brakingSystem: "Front Disc & Rear Drum",
      tyreSize: "90-90-12 (90/100-10)",
    },
  },
  {
    id: "cs2",
    name: "CR2 PRO / CS2",
    series: "GITANJALI",
    tagline: "Sport-tuned premium scooter with tubeless grip.",
    description:
      "The CR2 PRO / CS2 delivers a sharp, premium stance with dual disc braking and tubeless tyres for confident, responsive handling.",
    images: [
      scooterImage("cr2-procs2.png"),
      scooterImage("cr2-procs2-1.png"),
      scooterImage("cr2-procs2-2.png"),
    ],
    colorNames: ["Pearl White", "Racing Red", "Aqua Blue"],
    specs: {
      ...COMMON,
      voltage: "60V / 72V",
      wheelRim: "Stylish Alloy Rim",
      brakingSystem: "Front Disc & Rear Disc",
      tyreSize: "90-90-12 (Tubeless)",
    },
  },
  {
    id: "cr1pro",
    name: "CR1 PRO",
    series: "GITANJALI",
    tagline: "Refined commuter with tubeless dependability.",
    description:
      "The CR1 PRO combines an efficient voltage platform with tubeless tyres and hydraulic suspension for comfortable, low-maintenance daily commuting.",
    images: [
      scooterImage("cr1.png"),
      scooterImage("cr1-1.png"),
      scooterImage("cr1-2.png"),
    ],
    colorNames: ["Pearl White", "Racing Red", "Aqua Blue"],
    specs: {
      ...COMMON,
      voltage: "48V / 60V",
      wheelRim: "Iron",
      brakingSystem: "Front Disc & Rear Drum",
      tyreSize: "90-90-12 (Tubeless)",
    },
  },
  {
    id: "vm",
    name: "CR2 PRO / VM",
    series: "GITANJALI",
    tagline: "High-voltage premium ride with alloy styling.",
    description:
      "The CR2 PRO / VM offers a high-voltage platform, dual disc braking and tubeless tyres, wrapped in a confident, modern alloy-rim design.",
    images: [
      studioImage("vm-red.webp"),
      studioImage("vm-white.webp"),
      studioImage("vm-lavender.webp"),
    ],
    colorNames: ["Racing Red", "Pearl White", "Lavender"],
    specs: {
      ...COMMON,
      voltage: "60V / 72V",
      wheelRim: "Stylish Alloy Rim",
      brakingSystem: "Front Disc & Rear Disc",
      tyreSize: "90-90-12 (Tubeless)",
    },
  },
  {
    id: "e4",
    name: "CR2 PRO / E4",
    series: "GITANJALI",
    tagline: "Premium long-haul comfort, fully tubeless.",
    description:
      "The CR2 PRO / E4 rounds out the premium range with a high-voltage platform, dual disc braking and tubeless tyres for a smooth, planted ride.",
    images: [
      studioImage("e4-orange.webp"),
      studioImage("e4-white.webp"),
      studioImage("e4-grey.webp"),
    ],
    colorNames: ["Sunset Orange", "Pearl White", "Graphite Grey"],
    specs: {
      ...COMMON,
      voltage: "60V / 72V",
      wheelRim: "Stylish Alloy Rim",
      brakingSystem: "Front Disc & Rear Disc",
      tyreSize: "90-90-12 (Tubeless)",
    },
  },
];

// Ordered spec rows used in comparison and full spec views.
export const SPEC_ROWS = [
  { key: "motor", label: "Motor" },
  { key: "speedMeter", label: "Speed Meter" },
  { key: "voltage", label: "Voltage" },
  { key: "wheelRim", label: "Wheel Rim" },
  { key: "batteryType", label: "Battery Type" },
  { key: "brakingSystem", label: "Braking System" },
  { key: "suspension", label: "Suspension" },
  { key: "batteryAmpere", label: "Battery Ampere" },
  { key: "tyreSize", label: "Tyres Size" },
  { key: "maxLoading", label: "Max Loading" },
];

export const KEY_SPEC_KEYS = ["motor", "voltage", "brakingSystem", "maxLoading"];

export const getProductById = (id) => products.find((p) => p.id === id);
